import { createSvgIcon } from '@mui/material'

export const MattressIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194.311 194.311">
    <path d="M193.24,114.298l-21.582-39.247h0.207V38.735c0-7.426-6.041-13.467-13.467-13.467H35.913 c-7.426,0-13.467,6.041-13.467,13.467v36.316h0.207L1.07,114.298H193.24z M49.743,62.058c0-4.354,3.543-7.897,7.897-7.897h77.615 c5.135,0,9.313,4.177,9.313,9.312v1.68c0,5.134-4.178,9.312-9.313,9.312H59.055c-5.135,0-9.312-4.177-9.312-9.312V62.058z  M31.783,75.052h13.091c3.133,4.474,8.316,7.412,14.181,7.412h76.201c5.864,0,11.048-2.938,14.181-7.412h13.091l17.183,31.247H14.6 L31.783,75.052z M194.311,120.658v36.763c0,6.408-5.213,11.622-11.621,11.622H11.622C5.214,169.042,0,163.829,0,157.42v-36.763 H194.311z" />
  </svg>,
  'MattressIcon',
)
